// src/components/share/shareBackgrounds.ts
import bg1 from "@/assets/share/INNERGEM.APP 1.png";
import bg2 from "@/assets/share/INNERGEM.APP 2.png";
import bg3 from "@/assets/share/INNERGEM.APP 3.png";
import bg4 from "@/assets/share/INNERGEM.APP 4.png";
import bg5 from "@/assets/share/INNERGEM.APP 5.png";
import bg6 from "@/assets/share/INNERGEM.APP 6.png";
import bg7 from "@/assets/share/INNERGEM.APP 7.png";
import bg8 from "@/assets/share/INNERGEM.APP 8.png";
import bg9 from "@/assets/share/INNERGEM.APP 9.png";
import bg10 from "@/assets/share/INNERGEM.APP 10.png";
import bg11 from "@/assets/share/INNERGEM.APP 11.png";
import bg12 from "@/assets/share/INNERGEM.APP 12.png";
import bg13 from "@/assets/share/INNERGEM.APP 13.png";
import bg14 from "@/assets/share/INNERGEM.APP 14.png";
import bg15 from "@/assets/share/INNERGEM.APP 15.png";



export const SHARE_BACKGROUNDS: string[] = [
  bg1,
  bg2,
  bg3,
  bg4,
  bg5,
  bg6,
  bg7,
  bg8,
  bg9,
  bg10,
  bg11,
  bg12,
  bg13,
  bg14,
  bg15,
];

export function getRandomShareBackground() {
  const idx = Math.floor(Math.random() * SHARE_BACKGROUNDS.length);
  return SHARE_BACKGROUNDS[idx];
}
